<template>
  <div>
    <div id="dropdown" />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0">
          <div class="flex items-center justify-between bg-gray-200 md:flex-shrink-0 md:justify-center md:w-56">
            <Link class="mt-1 mb-1" href="/">
              <logo class="fill-white" width="120" height="50" />
            </Link>
            <dropdown class="md:hidden" placement="bottom-end">
              <template #default>
                <logo />
              </template>
              <template #dropdown>
                <div class="mt-2 px-8 py-4 bg-blue-800 rounded shadow-lg">
                  <!-- <main-menu :user="auth.user" :role="auth.user.role" /> -->
                </div>
              </template>
            </dropdown>
          </div>

          <div class="md:text-md flex items-center justify-between p-4 w-full text-sm bg-white border-b md:px-12 md:py-0">
            <div class="mr-4 mt-1">1$ = {{ change }} BsD</div>
            <div class="font-semibold text-xl">
              {{ time }}
            </div>
            <div class="flex items-center">
              <button
                v-if="$page.props.open_cash_register"
                type="button"
                @click="showCashAuditModal = true"
                class="mr-3 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-lg shadow-sm flex items-center gap-1.5 transition-colors cursor-pointer"
                title="Arqueo y Cierre de Caja"
              >
                <i class="fa fa-calculator"></i>
                <span class="hidden sm:inline">Arqueo / Cierre ({{ $page.props.open_cash_register.name }})</span>
                <span class="sm:hidden">Cerrar Caja</span>
              </button>

              <dropdown class="mt-1" placement="bottom-end">
                <template #default>
                  <div class="group flex items-center cursor-pointer select-none">
                    <div class="mr-1 text-gray-700 group-hover:text-blue-600 focus:text-blue-600 whitespace-nowrap">
                      <span>{{ auth.user.first_name }}</span>
                      <span class="hidden md:inline">&nbsp;{{ auth.user.last_name }}</span>
                    </div>
                    <icon class="w-5 h-5 fill-gray-700 group-hover:fill-blue-600 focus:fill-blue-600" name="cheveron-down" />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <button
                      v-if="$page.props.open_cash_register"
                      type="button"
                      @click="showCashAuditModal = true"
                      class="block px-6 py-2 w-full text-left font-semibold text-emerald-700 hover:text-white hover:bg-emerald-600 cursor-pointer"
                    >
                      <i class="fa fa-calculator mr-2"></i>Arqueo / Cierre de Caja
                    </button>
                    <Link v-if="auth.user.role === 'admin'" class="block px-6 py-2 hover:text-white hover:bg-blue-500" :href="`/users/${auth.user.id}/edit`">Mi perfil</Link>
                    <Link v-if="auth.user.role === 'admin'" class="block px-6 py-2 hover:text-white hover:bg-blue-500" href="/users">Usuarios</Link>
                    <button type="button" @click="handleLogout" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-blue-500 cursor-pointer">Cerrar sesión</button>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <!-- <main-menu class="hidden flex-shrink-0 p-12 w-56 bg-blue-900 overflow-y-auto md:block rounded-b-lg" /> -->
          <div class="px-4 py-8 md:flex-1 md:p-12 md:overflow-y-auto" scroll-region>
            <flash-messages />
            <slot />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Arqueo y Cierre Global -->
    <cash-audit-modal
      v-if="$page.props.open_cash_register"
      :show="showCashAuditModal"
      :cash-register-id="$page.props.open_cash_register.id"
      :register-name="$page.props.open_cash_register.name || ''"
      :cashier-name="auth.user.first_name"
      :is-admin="auth.user.role === 'admin'"
      :is-logging-out="isLoggingOut"
      @close="showCashAuditModal = false; isLoggingOut = false"
    />
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import Dropdown from '@/Shared/Dropdown'
import MainMenu from '@/Shared/MainMenu'
import FlashMessages from '@/Shared/FlashMessages'
import CashAuditModal from '@/Shared/CashAuditModal'

export default {
  components: {
    Dropdown,
    FlashMessages,
    Icon,
    Link,
    Logo,
    MainMenu,
    CashAuditModal
  },
  props: {
    auth: Object,
    change: Number
  },
  data() {
    return {
      date: '',
      time: '',
      showCashAuditModal: false,
      isLoggingOut: false
    }
  },
  mounted() {
    self = this
    self.time = self.update()
    setInterval(() => {
      self.time = self.update();
    }, 1000)
  },
  methods: {
    zeroPadding: (num, digit) => {
      var zero = '';
      for(var i = 0; i < digit; i++) {
        zero += '0';
      }
      return (zero + num).slice(-digit);
    },
    update: () => {
      let cd = new Date();
      let hours = '';
      let minutes = '';
      let secounds = '';
      let zero = '';

      for(let i = 0; i < 1; i++) {
        zero += '0';
      }
      hours = cd.getHours() > 9 ? cd.getHours() : (zero + cd.getHours())
      minutes =  cd.getMinutes() > 9 ? cd.getMinutes() : (zero + cd.getMinutes())
      secounds = cd.getSeconds() > 9 ? cd.getSeconds() :(zero + cd.getSeconds())

      return hours + ':' + minutes + ':' + secounds
    },
    handleLogout() {
      const openBox = this.$page.props.open_cash_register
      if (openBox) {
        const boxName = openBox.name || 'tu caja'
        if (confirm(`No puedes cerrar sesión porque tienes una caja abierta (${boxName}). Debes realizar el arqueo y cierre de tu caja primero.\n\n¿Deseas abrir la ventana de arqueo y cierre de caja ahora?`)) {
          this.isLoggingOut = true
          this.showCashAuditModal = true
        }
        return
      }
      this.$inertia.delete('/logout')
    }
  }
}
</script>
